export function randomBetween (minValue, maxValue) {
	return minValue + Math.random() * (maxValue - minValue);
}

/**
 * Randomize a value symmetrically around its nominal amount.
 *
 * Returns a uniformly distributed random number in the range
 * [value * (1 - jitterRatio), value * (1 + jitterRatio)], so the
 * result is re-randomized on every call.
 *
 * Used to de-synchronize periodic work across a fleet of devices
 * (e.g. refresh intervals, heartbeats) so timers that started at the
 * same moment drift apart instead of firing in lockstep.
 *
 * @param {number} value - Nominal value (e.g. an interval in ms). Must be >= 0.
 * @param {number} jitterRatio - Spread as a fraction of the value, expected 0..1.
 *   0.05 means the result lands between 95% and 105% of the value;
 *   0.5 means between 50% and 150%; 0 disables the jitter.
 *
 * @example
 * getJitteredValue(150000, 0.05) // heartbeat: 142500..157500 ms (±5%)
 * getJitteredValue(900000, 0.1)  // refresh: 810000..990000 ms (±10%)
 *
 * @returns {number} The jittered value.
 */
export function getJitteredValue (value, jitterRatio) {
	return randomBetween(value * (1 - jitterRatio), value * (1 + jitterRatio));
}
